import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { STATES } from '../../constants';
import { ErrorsConfig } from './errors.config';

export const ErrorsModule = angular
  .module(STATES.ERROR, [uiRouter])
  .config(ErrorsConfig);
